import environment from '../environment';

function formatTenantLink(tenantId: string, path: string): string {
  // `#` and `?` are URL delimiters (fragment/query start) — left raw, either
  // would truncate everything after it once this string is used as a URL,
  // dropping the rest of `path` (e.g. a Route's `?selectedId=...` query
  // string) instead of forwarding it to `/redir`. Escaping both keeps the
  // whole path intact through the request.
  const escapedPath = path.replace(/#/g, '%23').replace(/\?/g, '%3F');
  return `${environment.API_URL}/v1/tenants/${tenantId}/redir/${escapedPath}`;
}

export default formatTenantLink;
